/*
 * The threat-queue keyboard map, in one place. The help dialog and the
 * shortcut hints on action buttons read from here, so they can never
 * disagree with what the keys actually do (pages/Threats.jsx binds them).
 *
 * `keys` is the display form passed to <Kbd>; `id` is what Threats.jsx binds.
 */
export const INBOX_SHORTCUTS = [
  { group: 'Queue', id: 'next',     keys: 'J',        label: 'Next threat', short: 'next' },
  { group: 'Queue', id: 'prev',     keys: 'K',        label: 'Previous threat', short: 'previous' },
  { group: 'Queue', id: 'open',     keys: 'Enter',    label: 'Open the threat' },
  { group: 'Queue', id: 'select',   keys: 'X',        label: 'Select for bulk actions' },
  { group: 'Queue', id: 'first',    keys: 'G then G', label: 'First threat' },
  { group: 'Queue', id: 'last',     keys: '⇧G',       label: 'Last threat' },
  { group: 'Queue', id: 'filter',   keys: '/',        label: 'Filter the queue', short: 'filter' },

  { group: 'Triage', id: 'triage',  keys: 'T',        label: 'Start triage', short: 'triage' },
  { group: 'Triage', id: 'ack',     keys: 'A',        label: 'Acknowledge', short: 'ack' },
  { group: 'Triage', id: 'archive', keys: '⇧A',       label: 'Archive' },
  { group: 'Triage', id: 'assign',  keys: 'I',        label: 'Assign to me, or unassign' },
  { group: 'Triage', id: 'close',   keys: 'Esc',      label: 'Close the panel or clear the selection' },

  { group: 'Export', id: 'sigma',   keys: 'E',        label: 'Download Sigma rules (.yml)' },
  { group: 'Export', id: 'yara',    keys: '⇧E',       label: 'Download YARA rules (.yar)' },
  { group: 'Export', id: 'copyIocs', keys: 'C',       label: 'Copy IOCs to clipboard', short: 'copy IOCs' },
  { group: 'Export', id: 'downloadIocs', keys: '⇧C',  label: 'Download IOCs (.txt)' },

  { group: 'General', id: 'help',   keys: '?',        label: 'Show keyboard shortcuts', short: 'all shortcuts' },
  { group: 'General', id: 'palette', combo: 'mod+k',  label: 'Search and commands' },
  { group: 'General', id: 'navHome',     keys: 'G then H', label: 'Go to Home' },
  { group: 'General', id: 'navCreds',    keys: 'G then C', label: 'Go to Credentials' },
  { group: 'General', id: 'navSettings', keys: 'G then S', label: 'Go to Settings' },
];

export const SHORTCUT_GROUPS = ['Queue', 'Triage', 'Export', 'General'];

export const shortcutFor = (id) => INBOX_SHORTCUTS.find((s) => s.id === id);

/** Short hint list for the queue footer. */
export const FOOTER_SHORTCUTS = ['next', 'prev', 'triage', 'ack', 'filter', 'help'];
